import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { useLocation } from '@reach/router';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import Config from '../../../../../config';

import MainImage from './MainImage';

import Title, { TitleTypes } from '../../../Title';
import Text, { TextTypes } from '../../../Text';
import { LocalizedLink } from '../../../LocalizedLink';

const Slide = ({
    styles,
    rules,
    title,
    description,
    link,
    linkEN,
    linkType,
    isMoving,
    transitionDuration,
    mainImage,
    mainImageAlt,
    isActive,
    handleHover,
}) => {
    const { locale } = useIntl();
    const { pathname } = useLocation();

    const handleMouseHover = value => {
        handleHover && handleHover(value);
    };

    const isContactLink = link.url === Config.routes['/contact'];

    const LocaleBasedExternalLink = () => (
        <>
            {locale === 'cs' && (
                <a
                    onMouseEnter={() => handleMouseHover(false)}
                    onMouseLeave={() => handleMouseHover(true)}
                    href={link.url}
                    className={styles.link}
                >
                    <FormattedMessage id={link.text} />
                </a>
            )}
            {locale === 'en' && (
                <a
                    onMouseEnter={() => handleMouseHover(false)}
                    onMouseLeave={() => handleMouseHover(true)}
                    href={linkEN.url}
                    className={styles.link}
                >
                    <FormattedMessage id={linkEN.text} />
                </a>
            )}
        </>
    );

    const TypeBasedLink = () => (
        <>
            {linkType === Config.linkTypes.localized ? (
                <LocalizedLink
                    data-event-id={isContactLink ? 'contact-top' : undefined}
                    handleCarouselHover={handleMouseHover}
                    to={link.url}
                    className={
                        isContactLink
                            ? getPlausibleClassName(styles.link, AnalyticsEvent.CONTACT_TOP_CLICK, {
                                  origin_path: pathname,
                              })
                            : styles.link
                    }
                >
                    <FormattedMessage id={link.text} />
                </LocalizedLink>
            ) : (
                <LocaleBasedExternalLink />
            )}
        </>
    );

    return (
        <div className={styles.container}>
            <div className={styles.contentContainer}>
                <Title extend={{ title: rules.title }} as={TitleTypes.H4} type={TitleTypes.H4}>
                    <FormattedMessage id={title} />
                </Title>
                <Text type={TextTypes.LARGE} as="p">
                    <FormattedMessage id={description} />
                </Text>
                <TypeBasedLink />
            </div>
            <MainImage
                isMoving={isMoving}
                isActive={isActive}
                transitionDuration={transitionDuration}
                alt={mainImageAlt}
                src={mainImage}
            />
        </div>
    );
};

Slide.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    link: PropTypes.shape().isRequired,
    linkEN: PropTypes.shape(),
    linkType: PropTypes.string.isRequired,
    isMoving: PropTypes.bool.isRequired,
    transitionDuration: PropTypes.number.isRequired,
    mainImage: PropTypes.string.isRequired,
    mainImageAlt: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    handleHover: PropTypes.func,
};

Slide.defaultProps = {
    linkEN: null,
    handleHover: false,
};

export default Slide;
